import ReactDOM from 'react-dom';
import React from 'react';

import './styles/main.scss';
import './scripts/cards.js';
import './scripts/sameheight.js';
import './scripts/menu.js';
import './scripts/lightbox.js';
import './scripts/flipcards.js';
import './scripts/dropdown.js';

import './react/components/accordion.js';
import './react/components/searchcourses.js';
import SearchCourses from './react/components/searchcourses.js';
import Accordion from './react/components/accordion.js';

// On page load
document.addEventListener('DOMContentLoaded', function() {

  const searchCourses = document.querySelector('.mpy-search-courses');
  if (searchCourses) { 
    ReactDOM.render(<SearchCourses />, searchCourses);
  }

  const accordion = document.querySelectorAll('.mpy-accordion');
  if (accordion) {
    accordion.forEach((item) => {
      const accordionContent = item.getAttribute('data-accordion-content');
      const accordionLayout = item.getAttribute('data-accordion-layout');
      const accordionMode = item.getAttribute('data-accordion-mode');
      ReactDOM.render(<Accordion 
        content={accordionContent} 
        layout={accordionLayout}  
        mode={accordionMode}
      />, item);
    });
  }

  // Handle Gravity Form Course selection

  const courseSelect = document.querySelector('select[data-name="input_Course"]');

  const updateDateValues = () => {
    const course = document.querySelector('select[data-name="input_Course"]').value;
    
    // Let's get the course data from WP API
    fetch(`/wp-json/newtyne/v2/courses?id=${course}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.courses.length !== 1) {
          return;
        }
        const dates = data.courses[0].fields.dates;

        const dateSelect = document.querySelector('select[data-name="input_Select a date"]');
        dateSelect.innerHTML = '';
        // Add back default option
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.innerHTML = 'Select a date';
        dateSelect.appendChild(defaultOption);

        if(dates) {
          dates.forEach((date) => {
            const option = document.createElement('option');
            // Each date is an object with a date_from and date_to
            option.value = date.date_from;
            option.innerHTML = `${date.date_from} - ${date.date_to}`;
            dateSelect.appendChild(option);
          });
        }


      });
  }

  if (courseSelect) {
    courseSelect.addEventListener('change', (e) => {
      updateDateValues();
    });

    updateDateValues();
  }


  // Handle Gravity Form Course selection

  
  const courseTypeSelect = document.querySelector('select[data-name="input_Course Type"]');

  const updateCourseValues = () => {
    const courseTypeValue = document.querySelector('select[data-name="input_Course Type"]').value;
    
    // Let's get the course data from WP API
    fetch(`/wp-json/newtyne/v2/courses?course_category=${courseTypeValue}`)
      .then((response) => response.json())
      .then((data) => {

        const courseSelect = document.querySelector('select[data-name="input_Course"]');
        courseSelect.innerHTML = '';
        // Add back default option
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.innerHTML = 'Select a course';
        courseSelect.appendChild(defaultOption);

        data.courses.forEach((course) => {
          const option = document.createElement('option');
          // Each date is an object with a date_from and date_to
          option.value = course.ID;
          option.innerHTML = course.post_title;
          courseSelect.appendChild(option);
        });


      });
  }

  if (courseTypeSelect) {
    courseTypeSelect.addEventListener('change', (e) => {
      updateCourseValues();
    });

    updateCourseValues();
  }

  const updateBookNowValues = () => {
    const dataInput = document.querySelector('input[name="dates"]');
    const selectDateDropdown = document.querySelector('.selectdate select');
    
    if (selectDateDropdown && dataInput && dataInput.value !== '') {
      const data = JSON.parse(dataInput.value);
      
      // Remove all options
      selectDateDropdown.innerHTML = '';
      // Add back default option
      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.innerHTML = 'Select a date';
 
      selectDateDropdown.appendChild(defaultOption);

      data.forEach((date) => {
        const baseDate = date.date_from.split('/')
        const usToUkDate = baseDate[1] + '/' + baseDate[0] + '/' + baseDate[2];
        const dateObject = new Date(usToUkDate);
        const todayAtMidnight = new Date();
        todayAtMidnight.setHours(0,0,0,0);

        if (dateObject < todayAtMidnight) {
          return;
        }
        const option = document.createElement('option');
        // Each date is an object with a date_from and date_to
        option.value = date.date_from;
        option.innerHTML = `${date.date_from} - ${date.date_to}`;
        selectDateDropdown.appendChild(option);
      }
      );
    } else {
      // Remove the select date dropdown
      const selectDateDropdown = document.querySelector('.selectdate');
      if (selectDateDropdown) {
        selectDateDropdown.remove();
      }
    }
  } 

  updateBookNowValues();
});
